import { useQuery, type QueryKey, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

type QueryFn<T> = () => Promise<T>;
type SupabaseQueryOptions<TData> = Omit<UseQueryOptions<TData, Error, TData, QueryKey>, 'queryKey' | 'queryFn'>;

export function useSupabaseQuery<TData>(
  key: QueryKey,
  queryFn: QueryFn<TData>,
  options?: SupabaseQueryOptions<TData>
): UseQueryResult<TData, Error> {
  const client = supabase;
  if (!client) {
    console.warn('Supabase client is not configured. Queries will be skipped.');
  }

  return useQuery({
    queryKey: key,
    queryFn,
    enabled: Boolean(client),
    ...options,
  });
}
